function createAstrolabeImageExportOptions (onclone) {
  return {
    backgroundColor: null,
    useCORS: true,
    scale: 4,
    onclone
  }
}

module.exports = {
  createAstrolabeImageExportOptions
}
